<template>
<div class="animated-number">
    <span v-if="formattedNumber < 10 && addZero">0</span>
    <span>{{formattedNumber}}</span>
    <span v-if="unit">{{unit}}</span>
</div>
</template>

<script>
    export default {
    name: 'AnimateText',
        data () {
                return {
                    interval: false,
                    displayNumber: 0
                }
            },
            props:{
                unit: {
                    type: String,
                    },
                number: {
                    type: Number,
                    default: 0
                    },
                animateTime: {
                    type: Number,
                    default: 20
                    },
                addZero: Boolean
            },
            methods:{
                animateFunction(){
                    //  if(this.number == Infinity){console.log("Infinitetete"), this.number = 0 }     
                this.interval = setInterval(function(){
                    
                    if(this.number == this.displayNumber){
                        clearInterval(this.interval);
                        return;
                    }
                    if(this.displayNumber != this.number){
                        // console.log("countup")
                    let change = (this.number - this.displayNumber) / 10;
                    change = change >= 0 ? Math.ceil(change) : Math.floor(change);
                    this.displayNumber = this.displayNumber + change;
                    }
                }.bind(this), this.animateTime);
            }
        },

            computed:{
                formattedNumber(){return this.displayNumber.toLocaleString().replace(/\./g, ' ')}
            },
            watch:{ number: function(){ this.animateFunction() } },
            created(){
                this.animateFunction()
            }
     
    }  
</script>

<style lang="less">

</style>